import moment from 'moment';
import Holidays from "date-holidays";



export const isHoliday = (day: string) => {
  const hd = new Holidays("SN");
  const fullYear = new Date().getFullYear();
  const holidays = hd.getHolidays(fullYear);
  return holidays.find(holiday => moment(holiday.date).format("YYYY-MM-DD") === day);
}
